import { faCalendar, faUser } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useContext, useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Button, Dropdown, DropdownButton } from "react-bootstrap";
import { BasicContext } from "../App";
import { faBan, faEllipsisV, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { postMethod } from "../requests";
import ConfirmModal from "./modals/ConfirmModal";

const Reservation = (props) => {
    const { t } = useTranslation();
    const { reserv, reloadData, onlyDisplay, reservView } = props;
    const { changeView, showView, checkServerData, setAlerts } = useContext(BasicContext);
    const [showCancelReservationModal, setShowCancelReservationModal] = useState(false);

    const cancelReservation = async (r) => {
        const res = await postMethod(
            showView.params.moduleName === "ADMIN_APP" ? "/cancel-reservation" : "/cancel-own-reservation",
            showView.params.moduleName === "ADMIN_APP" ? { urID: r.urID, userID: r.userID } : { urID: r.urID }
        );
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "cancelledReserv" }]);
            reloadData();
        }
    };

    return (
        <Fragment>
            <tr
                className={`${!reserv.u2c_id && new Date() > new Date(reserv.ur_end_date) ? "class-cancelled" : ""} class-lvl-bg-${
                    reserv.class_level_colour ? reserv.class_level_colour : "white"
                }`}
            >
                <td rowSpan={2} className="text-center pe-0 pe-lg-2 border-bottom-0 pb-0 ">
                    <FontAwesomeIcon icon={faCalendar} />
                </td>
                <td className="border-bottom-0 pb-0 bold">{moment(reserv.class_start_time).format("DD.MM.YYYY")}</td>
                <td className="border-bottom-0 pb-0 bold">{reserv.class_name}</td>
                <td
                    className={`border-bottom-0 py-1 w-25 text-break lh-1 ${!reserv.u2c_id && new Date() > new Date(reserv.ur_end_date) && "text-decoration-none text-secondary"}`}
                    rowSpan={2}
                >
                    {reserv.u2c_id ? (
                        <span className="text-success bold">{t("reservations.usedReservation")}</span>
                    ) : !reserv.u2c_id && new Date() <= new Date(reserv.ur_end_date) ? (
                        <span className="">{t("reservations.notYetUsedReservation")}</span>
                    ) : (
                        <span className="">{t("reservations.reservationExpired")}</span>
                    )}
                </td>
                {!onlyDisplay && (
                    <td className="text-center" rowSpan={reservView && showView.params.moduleName === "ADMIN_APP" ? 4 : 3}>
                        {!reserv.u2c_id && new Date() <= new Date(reserv.ur_end_date) && (
                            <DropdownButton
                                id="dropdownMoreOptions"
                                variant="outline-secondary"
                                className="d-inline-block"
                                size="sm"
                                title={<FontAwesomeIcon icon={faEllipsisV} />}
                            >
                                {showView.params.moduleName === "APP" && (
                                    <Dropdown.Item
                                        as={Button}
                                        variant="link"
                                        onClick={() => changeView({ nav: "reservations", sub: "useReservation", params: { reserv: reserv } })}
                                    >
                                        <FontAwesomeIcon icon={faRotateRight} className="me-2" />
                                        {t("reservations.useReservation")}
                                    </Dropdown.Item>
                                )}
                                <Dropdown.Item as={Button} variant="link" onClick={() => setShowCancelReservationModal({ urID: reserv.ur_id, userID: reserv.user_id })}>
                                    <FontAwesomeIcon icon={faBan} className="me-2" />
                                    {t("reservations.cancelReservation")}
                                </Dropdown.Item>
                            </DropdownButton>
                        )}
                    </td>
                )}
            </tr>
            <tr
                className={`${!reserv.u2c_id && new Date() > new Date(reserv.ur_end_date) ? "class-cancelled" : ""} class-lvl-bg-${
                    reserv.class_level_colour ? reserv.class_level_colour : "white"
                }`}
            >
                <td className="border-bottom-0 pb-0 pt-0 pt-lg-2 bold">
                    {moment(reserv.class_start_time).format("HH:mm")}-{moment(reserv.class_end_time).format("HH:mm")}
                </td>
                <td className="border-bottom-0 pb-0 pt-0 pt-lg-2">
                    {reserv.instructor_name} {reserv.instructor_surname}
                </td>
            </tr>

            {reservView && showView.params.moduleName === "ADMIN_APP" && (
                <tr
                    className={`${!reserv.u2c_id && new Date() > new Date(reserv.ur_end_date) ? "class-cancelled" : ""} class-lvl-bg-${
                        reserv.class_level_colour ? reserv.class_level_colour : "white"
                    }`}
                >
                    <td className="border-bottom-0 pb-0 pt-0 pt-lg-2"></td>

                    <td colSpan={3} className="border-bottom-0 pb-0 pt-0 pt-lg-2">
                        {t("reservations.reservationFor")}:{" "}
                        <span className="bold">
                            <FontAwesomeIcon icon={faUser} className="me-1 me-lg-2" />
                            {!reserv.u2c_id && new Date() > new Date(reserv.ur_end_date) ? (
                                <>
                                    {reserv.user_name} {reserv.user_surname}
                                </>
                            ) : onlyDisplay ? (
                                <span>
                                    {reserv.user_name} {reserv.user_surname}
                                </span>
                            ) : (
                                <Button variant="link" className="p-0" onClick={() => changeView({ nav: "users", sub: "userDetails", params: { userID: reserv.user_id } })}>
                                    {reserv.user_name} {reserv.user_surname}
                                </Button>
                            )}
                        </span>
                    </td>
                </tr>
            )}
            <tr
                className={`pt-0 pt-lg-2 ${!reserv.u2c_id && new Date() > new Date(reserv.ur_end_date) ? "class-cancelled" : ""} class-lvl-bg-${
                    reserv.class_level_colour ? reserv.class_level_colour : "white"
                }`}
            >
                <td className="pt-0 pt-lg-2"></td>
                <td className="pt-0 pt-lg-2" colSpan={3}>
                    {t("reservations.reservationValidTill")}: <span className="bold">{moment(reserv.ur_end_date).format("YYYY-MM-DD HH:mm:ss")}</span>
                </td>
            </tr>

            {showCancelReservationModal && (
                <ConfirmModal
                    show={true}
                    title={t("cancelReservationModal.title")}
                    text={t("cancelReservationModal.text")}
                    proceedTxt={t("cancelReservationModal.proceedTxt")}
                    cancelTxt={t("cancelReservationModal.cancelTxt")}
                    onClose={() => setShowCancelReservationModal(false)}
                    onProceed={() => cancelReservation(showCancelReservationModal)}
                />
            )}
        </Fragment>
    );
};

export default Reservation;
